// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2P36e","newExpiryDate":"styles_newExpiryDate__MguWt","footer":"styles_footer__3Cit0"};